import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconChecklist } from "@tabler/icons-react";
import { DatosServiciosGestionServiciosDef } from "./DatosServiciosGestionServiciosDef";

export const DatosServiciosIcon = IconChecklist;
export const DatosServiciosHelpText = '* Datos Servicios Gestión';

export class DatosServiciosGestionServicios extends Entity<DatosServiciosGestionServiciosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosGestionServiciosDef(), parentKeys);
        this.Form = import('./DatosServiciosGestionServiciosForm').then((module) => module.DatosServiciosGestionServiciosForm);
        this.Title = "Gestionar Reporte";
        this.HelpText = DatosServiciosHelpText;
        this.Icon = DatosServiciosIcon;
    }
}